/**
 * Interruttori di visibilità delle funzioni AI in app.
 *
 * Servono a **pilotare l'uso verso il connettore MCP** senza smontare niente:
 * il codice resta dov'è, spento solo in facciata, e si riaccende cambiando una
 * riga qui. Spegnere davvero una funzione vorrebbe dire cancellarla, e con la
 * beta coach appena partita (19/10/2026) non è il momento di quella decisione.
 *
 * ATTENZIONE: questi flag **non sono un controllo di sicurezza**. Gli endpoint
 * restano esposti e protetti come prima — dal ruolo e dal flag per-coach
 * `ai_enabled` lato backend. Qui si decide cosa vede il coach, non cosa può
 * fare chi costruisce una richiesta a mano.
 */

/**
 * Documenti formativi: pagina `/ai-training-docs`, voce di menu, e la sezione
 * "Documenti di piattaforma" dentro il selettore fonti della chat.
 *
 * Spenti perché nel flusso che vogliamo far prendere ai coach non portano
 * valore: il contesto si dà al prompt e si affina conversando (decisione O-5
 * di docs/ai-program/10-byok-and-mcp-rework.md). Lasciarli visibili offriva
 * una funzione da curare senza che nessuno la stesse usando.
 *
 * Cosa NON cambia:
 *  - i documenti già caricati restano leggibili dal connettore MCP, che espone
 *    `get_training_docs` e `search_knowledge` (backend/services/ai_tools/catalog.py).
 *    Nascondere la gestione non li toglie dal catalogo degli strumenti;
 *  - l'amministrazione dei documenti nel pannello admin resta accesa: è da lì
 *    che si riparte se si decide di riaccenderli.
 */
export const AI_TRAINING_DOCS_VISIBLE = false;
